
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import globalThis_1 from './global-this.js';
import isObject$1 from './is-object.js';

var globalThis = globalThis_1;
var isObject = isObject$1;

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

export { documentCreateElement as default };
//# sourceMappingURL=document-create-element.js.map
